import { FC } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import { IProps } from './type';

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const PieChart: FC<IProps> = ({ policyDistributions }) => {
  const labelMap: Record<
    keyof typeof policyDistributions,
    { name: string; color: string }
  > = {
    TransportationPolicy: { name: 'Nakliyat Poliçeleri', color: '#D5B8A1' },
    MotorInsurance: { name: 'Oto Poliçeler', color: '#F4ECC2' },
    DomesticInsurance: { name: 'Yurtiçi Poliçeler', color: '#FAD7A0' },
    AbroadInsurance: { name: 'Yurtdışı Poliçeler', color: '#D7BDE2' },
    OtherInsurance: { name: 'Master Poliçeler', color: '#F1948A' },
    TravelHealthInsurance: { name: 'Seyahat Sağlık', color: '#E9967A' },
    GroupHealthInsurancePolicies: {
      name: 'GrupSağlık Poliçeler',
      color: '#AED6F1',
    },
  };

  const data = Object.entries(policyDistributions ?? {}).map(([key, value]) => {
    const label = labelMap[key as keyof typeof policyDistributions];
    if (label) {
      const { name, color } = label;
      return { name, value, color };
    } else {
      return { name: key, value, color: '#CCCCCC' };
    }
  });

  const chartData = {
    labels: data.map((entry) => entry.name),
    datasets: [
      {
        data: data.map((entry) => entry.value),
        backgroundColor: data.map((entry) => entry.color),
        borderColor: 'transparent',
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: '70%',
    plugins: {
      legend: {
        position: 'right' as const,
        labels: {
          usePointStyle: true,
        },
      },
    },
  };

  return (
    <div
      style={{
        width: '300px',
        height: '300px',
        padding: '10px',
      }}
    >
      <Pie data={chartData} options={options} />
    </div>
  );
};

export default PieChart;
